import { Button, ButtonProps, ButtonVariantType } from '@givebutter/primitives/button';
import { faDownload } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCurrentLetter } from 'assets/js/pages/engage/letters/useCurrentLetter';
import { useCurrentLetterPreview } from 'assets/js/pages/engage/letters/useCurrentLetterPreview';
import { useAppState } from 'customHooks/useAppState';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { twMerge } from 'tailwind-merge';

interface LetterDownloadPreviewButtonProps extends Omit<ButtonProps, 'variant'> {
    variant?: ButtonVariantType;
}

const LetterDownloadPreviewButton = (props: LetterDownloadPreviewButtonProps) => {
    const {
        className = '',
        size = 'sm',
        variant = 'outline',
        color = 'neutral',
        ...restProps
    } = props;
    const { apiUrl } = useAppState();
    const { accountId } = useCurrentAccount();
    const { data: letter } = useCurrentLetter();
    const query = useCurrentLetterPreview();
    const { data: previewStatus } = query;

    if (!letter) {
        return null;
    }

    if (letter.settings.send_to_print_and_mail_service && !previewStatus?.status) {
        return (
            <Button
                disabled
                variant={variant}
                size={size}
                color={color}
                className={twMerge('flex items-center gap-1 whitespace-nowrap', className)}
                {...restProps}
            >
                <FontAwesomeIcon icon={faDownload} />
                <p className={'hidden sm:block'}>Download preview</p>
            </Button>
        );
    }

    return (
        <a
            href={`${apiUrl}/dashboard/accounts/${accountId}/messages/${letter.id}/preview?mode=attachment`}
            download={true}
        >
            <Button
                variant={variant}
                size={size}
                color={color}
                className={twMerge('flex items-center gap-1 whitespace-nowrap', className)}
                {...restProps}
            >
                <FontAwesomeIcon icon={faDownload} />
                <p className={'hidden sm:block'}>Download preview</p>
            </Button>
        </a>
    );
};

export { LetterDownloadPreviewButton };
